<a
  class="skip visually-hidden"
  href="#mng-main"
  [attr.inert]="pageInert() ? '' : null"
  (click)="skipToMain($event)"
  >Skip to content</a
>
<header class="topbar" [attr.inert]="pageInert() ? '' : null">
  <button
    #menuButton
    class="menu-button"
    type="button"
    aria-controls="mng-sidebar"
    [attr.aria-expanded]="menuOpen()"
    [attr.aria-label]="menuOpen() ? 'Close navigation' : 'Open navigation'"
    (click)="toggleMenu()"
  >
    <mng-icon [name]="menuOpen() ? 'x' : 'menu'" aria-hidden="true" />
  </button>
  <a class="topbar-brand" routerLink="/" aria-label="Canvas Builder Management">
    <span class="mark" aria-hidden="true">
      <mng-icon name="package" />
    </span>
    <span class="topbar-title" aria-hidden="true">Canvas Builder</span>
  </a>
</header>
@if (menuOpen()) {
  <div class="backdrop" aria-hidden="true" (click)="closeMenu()"></div>
}
<aside
  id="mng-sidebar"
  class="sidebar"
  [class.open]="menuOpen()"
  [attr.inert]="drawerInert() ? '' : null"
>
  <div class="brand-row">
    <a
      class="wordmark"
      routerLink="/"
      aria-label="Canvas Builder Management"
      (click)="chooseLink()"
    >
      <span class="mark" aria-hidden="true">
        <mng-icon name="package" />
      </span>
      <span class="wordmark-names" aria-hidden="true">
        <span class="wordmark-title">Canvas Builder</span>
        <span class="wordmark-sub">Management</span>
      </span>
    </a>
    @if (!desktop()) {
      <button
        type="button"
        class="close"
        aria-label="Close navigation"
        (click)="closeMenu()"
      >
        <mng-icon name="x" aria-hidden="true" />
      </button>
    }
  </div>
  <nav aria-label="Tools">
    <p class="nav-title">Tools</p>
    <a
      #firstNavLink
      routerLink="/"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
      ariaCurrentWhenActive="page"
      (click)="chooseLink()"
    >
      <mng-icon name="home" aria-hidden="true" />Home
    </a>
    @if (auth.isCatalogAdmin()) {
      <a
        routerLink="/products"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
        (click)="chooseLink()"
      >
        <mng-icon name="package" aria-hidden="true" />Products
      </a>
    }
    <a
      routerLink="/conversions"
      routerLinkActive="active"
      ariaCurrentWhenActive="page"
      (click)="chooseLink()"
    >
      <mng-icon name="repeat" aria-hidden="true" />Conversions
    </a>
  </nav>
  <div class="footer">
    @if (username(); as name) {
      <div class="user">
        <span class="avatar" aria-hidden="true">{{ initial() }}</span>
        <span class="who" [attr.title]="name">{{ name }}</span>
      </div>
    }
    <button type="button" class="signout" (click)="auth.logout()">
      <mng-icon name="log-out" aria-hidden="true" />Sign out
    </button>
  </div>
</aside>
<main #main id="mng-main" tabindex="-1" [attr.inert]="pageInert() ? '' : null">
  <router-outlet />
</main>
